export const base64DecodeToLong = code => {
    var decodedString = atob(code);

    var decodedNumber = parseInt(decodedString, 10);

    return Number(decodedNumber);
};
